import './consentsByType.less'
import WidgetCard from '../../../components/WidgetCard'
import ChartPieWithList from '../../../components/ChartPieWithList/chartPieWithList'
import DefaultViewNoContent from '../components/defaultViewNoContent/defaultViewNoContent'
import SvgNoPreferenceCenter from '../../../assets/inlineSvg/icon-consent-mgmt-no-preference-center.svg'
import SvgNoValuePreferencCenterDatasource from '../../../assets/inlineSvg/icon-consent-mgmt-no-value-PrefeCenter-Datasource.svg'
import { DOC_CLASSIFICATION_COLORS } from '../../dashboards/mainDashboardv2/constants'
import { getShowLoader } from '../../../reducers/requestReducer'
import { RootState } from '../../../rootReducer'
import { getUpdatedUrl } from '../../../utils/urlUtil'
import {
  ConsentsByKey,
  fetchConsentManagementConsentByPreferenceCenterListWidget,
  fetchConsentManagementConsentCategoriesByPreferenceCenterId,
  ACTION_CM_CONSENTBY_TYPE_PREFERENCECENTER_CATEGORIES_WIDGET,
  ACTION_CONSENT_MANAGEMENT_CONSENTBY_PREFENRENCECENTER_LIST_WIDGET,
  fetchConsentOptStats
} from '../consentManagementSlice'
import {
  CONSENT_TYPES,
  DEFAULT_LANGUAGE,
  FILTER_OPT_STATUS,
  FILTER_PREFERENCE_CATEGORY,
  FILTER_PREFERENCE_CENTER,
  URL_CONSENT_LOG,
  URL_CONSENT_MANAGEMENT,
  URL_PREFERENCE_CENTER,
  URL_PREFERENCE_CENTER_DETAILS
} from '../../../constants'
import LoaderView from '../../../components/Loader/loader'
import historyService from '../../../services/historyService'
import CustomTooltip from '../../../components/ChartTooltipV2'
import DefaultNoViewContentType2 from '../components/defaultNoViewContentType2/defaultNoViewContentType2'
import ChartBarLegends from '../components/chartBarLegends/chartBarLegends'
import { useIntl } from 'react-intl'
import { connect, useSelector } from 'react-redux'
import React, { SyntheticEvent, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowSquareIn as SvgLink } from 'phosphor-react'
import { Typography } from '@lightbeamai/design-system'
import classNames from 'classnames'

interface IProps {
  consentsByPreferenceCenterList?: ConsentsByKey[]
  consentsCategoriesByPreferenceCenter?: ConsentsByKey[]
  preferenceCenterTotalConsentRecordCount?: number
  totalPreferenceCenters?: number
  totalOptIns?: number
  totalOptOuts?: number
  timePeriod?: string
  fetchConsentManagementConsentByPreferenceCenterListWidget: (timePeriod?: string) => void
  fetchConsentManagementConsentCategoriesByPreferenceCenterId: (preferenceGroupId?: string) => void
  fetchConsentOptStats: (timePeriod: string) => void
  showLoaderPreferenceList
  showLoaderConsentCategories
  showSummary?: any
  showPreferenceCenterDropdown?: boolean
  widgetTitle?: string
  totalLegendText?: string
}

const ConsentsByTypeWidget = (props: IProps) => {
  const {
    consentsByPreferenceCenterList = [],
    consentsCategoriesByPreferenceCenter = [],
    fetchConsentManagementConsentByPreferenceCenterListWidget,
    fetchConsentManagementConsentCategoriesByPreferenceCenterId,
    fetchConsentOptStats,
    preferenceCenterTotalConsentRecordCount,
    totalPreferenceCenters,
    totalOptIns = 0,
    totalOptOuts = 0,
    timePeriod = '',
    showLoaderPreferenceList,
    showLoaderConsentCategories,
    showSummary = false,
    showPreferenceCenterDropdown = true,
    widgetTitle,
    totalLegendText
  } = props

  const intl = useIntl()
  const language = useSelector((state: RootState) => state.lang.language)

  const optiontop5PreferenceCenters = intl.formatMessage({
    id: 'consentManagement.top5PreferenceCenters'
  })

  const [selectedOption, setSelectedOption] = useState('')

  useEffect(() => {
    if (consentsByPreferenceCenterList.length > 1) {
      setSelectedOption(optiontop5PreferenceCenters)
    } else {
      setSelectedOption(consentsByPreferenceCenterList[0]?.id as string)
    }
  }, [consentsByPreferenceCenterList])

  useEffect(() => {
    fetchConsentManagementConsentByPreferenceCenterListWidget(timePeriod)
  }, [timePeriod, fetchConsentManagementConsentByPreferenceCenterListWidget])

  useEffect(() => {
    if (consentsByPreferenceCenterList.length === 1) {
      fetchConsentManagementConsentCategoriesByPreferenceCenterId(
        consentsByPreferenceCenterList[0]?.preferenceGroupId
      )
    }
  }, [consentsByPreferenceCenterList, fetchConsentManagementConsentCategoriesByPreferenceCenterId])

  useEffect(() => {
    showSummary && fetchConsentOptStats(timePeriod)
  }, [showSummary, timePeriod, fetchConsentOptStats])

  const consentsByPreferenceCenterListData = useMemo(
    () =>
      [...consentsByPreferenceCenterList].slice(0, 5).map((item, i) => {
        const url = getUpdatedUrl({
          pathName:
            URL_CONSENT_MANAGEMENT +
            URL_PREFERENCE_CENTER_DETAILS +
            `/${item.id}` +
            URL_CONSENT_LOG,
          pageName: URL_CONSENT_LOG
        })
        return {
          id: item.id,
          preferenceCenterGroupId: item.preferenceGroupId,
          key: `${item.name}`,
          value: item.total,
          color: DOC_CLASSIFICATION_COLORS[i],
          link: url,
          additionalData: item.consentData,
          onClick: () => historyService.push(url)
        }
      }),
    [consentsByPreferenceCenterList]
  )

  const consentsCategoriesByPreferenceCenterListData = useMemo(
    () =>
      [...consentsCategoriesByPreferenceCenter].map((item, i) => {
        const url = getUpdatedUrl({
          pathName:
            URL_CONSENT_MANAGEMENT +
            URL_PREFERENCE_CENTER_DETAILS +
            `/${selectedOption}` +
            URL_CONSENT_LOG,
          pageName: URL_CONSENT_LOG,
          pageQueryParams: {
            [FILTER_PREFERENCE_CATEGORY]: item.id as string
          }
        })
        return {
          key: `${item.name}`,
          value: item.total,
          color: DOC_CLASSIFICATION_COLORS[i],
          link: url,
          additionalData: item.consentData,
          onClick: () => historyService.push(url)
        }
      }),
    [consentsCategoriesByPreferenceCenter]
  )

  const getTotalConsentsUrl = useMemo(() => {
    const selectedPreferenceCenterOption = consentsByPreferenceCenterList?.find(
      (preferenceCenter) => preferenceCenter?.id === selectedOption
    )
    if (selectedOption === optiontop5PreferenceCenters) {
      return getUpdatedUrl({
        pathName: URL_CONSENT_MANAGEMENT + URL_CONSENT_LOG,
        pageName: URL_CONSENT_LOG,
        pageQueryParams: {
          [FILTER_PREFERENCE_CENTER]:
            consentsByPreferenceCenterListData
              ?.map((item) => item?.preferenceCenterGroupId)
              .join(',') || ''
        }
      })
    }
    return getUpdatedUrl({
      pathName:
        URL_CONSENT_MANAGEMENT +
        URL_PREFERENCE_CENTER_DETAILS +
        `/${selectedPreferenceCenterOption?.id}` +
        URL_CONSENT_LOG,
      pageName: URL_CONSENT_LOG
    })
  }, [selectedOption])

  const allValuesAreZeroForPreferenceCenterListData = useMemo(
    () => consentsByPreferenceCenterListData.every((item) => item.value === 0),
    [consentsByPreferenceCenterListData]
  )

  const allValuesAreZeroForConsentCategoriesListData = useMemo(
    () => consentsCategoriesByPreferenceCenterListData.every((item) => item.value === 0),
    [consentsCategoriesByPreferenceCenterListData]
  )

  const consentsByPreferenceCenterOptions = [
    ...(consentsByPreferenceCenterList.length > 1
      ? [
          {
            key: optiontop5PreferenceCenters,
            value: optiontop5PreferenceCenters,
            label: optiontop5PreferenceCenters
          }
        ]
      : []),
    ...consentsByPreferenceCenterList.map((preferenceCenter) => ({
      key: preferenceCenter.id as string,
      value: preferenceCenter.id as string,
      label: preferenceCenter.name
    }))
  ]

  const handleChangeDropdown = (_: SyntheticEvent, data: any) => {
    const selectedPreferenceCenterOption = consentsByPreferenceCenterList?.find(
      (preferenceCenter) => preferenceCenter?.id === data?.value
    )
    setSelectedOption(data.value)
    if (data.value !== optiontop5PreferenceCenters) {
      fetchConsentManagementConsentCategoriesByPreferenceCenterId(
        selectedPreferenceCenterOption?.preferenceGroupId
      )
    }
  }

  const urlOptIns = getUpdatedUrl({
    pathName: URL_CONSENT_MANAGEMENT + URL_CONSENT_LOG,
    pageName: URL_CONSENT_LOG,
    pageQueryParams: { [FILTER_OPT_STATUS]: CONSENT_TYPES.subscribed }
  })
  const urlOptOuts = getUpdatedUrl({
    pathName: URL_CONSENT_MANAGEMENT + URL_CONSENT_LOG,
    pageName: URL_CONSENT_LOG,
    pageQueryParams: { [FILTER_OPT_STATUS]: CONSENT_TYPES.unsubscribed }
  })

  return (
    <div className="consents-by-type">
      <WidgetCard
        className="consent-mgmt-widget"
        widgetTitle={{
          bordered: true,
          title:
            widgetTitle ||
            intl.formatMessage({ id: 'consentManagement.consentsByPreferenceCenter' }),
          dropdowns: [
            ...(showPreferenceCenterDropdown
              ? [
                  {
                    options:
                      consentsByPreferenceCenterOptions?.length > 1 &&
                      !allValuesAreZeroForPreferenceCenterListData
                        ? consentsByPreferenceCenterOptions
                        : [],
                    selected: selectedOption,
                    onChange: handleChangeDropdown
                  }
                ]
              : [])
          ],
          titleInfo: consentsByPreferenceCenterOptions.length === 1 &&
            !allValuesAreZeroForPreferenceCenterListData && (
              <Link to={consentsByPreferenceCenterListData[0].link} className="cm-redirect-link">
                <SvgLink size={20} weight="regular" /> {consentsByPreferenceCenterListData[0].key}
              </Link>
            ),
          titleInfoText:
            consentsByPreferenceCenterOptions.length === 1 &&
            !allValuesAreZeroForPreferenceCenterListData
              ? consentsByPreferenceCenterListData[0].key
              : ''
        }}
      >
        <LoaderView
          size="small"
          showLoader={showLoaderPreferenceList || showLoaderConsentCategories}
        />
        <div className="align-start">
          {showSummary ? (
            <div className="xs-mr-32">
              <Link
                to={`${URL_CONSENT_MANAGEMENT}${URL_PREFERENCE_CENTER}`}
                className="lb-summary-total-counts xs-mb-8 xs-px-8 xs-py-4"
              >
                <Typography variant={'basePlus6'} type={'strong'}>
                  {consentsByPreferenceCenterList.length || 0}
                </Typography>
                <Typography variant={'baseMinus2'} type={'medium'}>
                  {intl.formatMessage({ id: 'consentManagement.totalPreferenceCenters' })}
                </Typography>
              </Link>
              <Link className="lb-summary-total-counts xs-mb-8 xs-px-8 xs-py-4" to={urlOptIns}>
                <Typography variant={'basePlus6'} type={'strong'}>
                  {totalOptIns}
                </Typography>
                <Typography variant={'baseMinus2'} type={'medium'}>
                  {intl.formatMessage({ id: 'consentManagement.optIns' })}
                </Typography>
              </Link>
              <Link className="lb-summary-total-counts xs-mb-8 xs-px-8 xs-py-4" to={urlOptOuts}>
                <Typography variant={'basePlus6'} type={'strong'}>
                  {totalOptOuts}
                </Typography>
                <Typography variant={'baseMinus2'} type={'medium'}>
                  {intl.formatMessage({ id: 'consentManagement.optOuts' })}
                </Typography>
              </Link>
            </div>
          ) : (
            <></>
          )}
          <div className="full-flex">
            {totalPreferenceCenters === 0 ? (
              <DefaultViewNoContent
                SvgIcon={SvgNoPreferenceCenter}
                header={intl.formatMessage({
                  id: 'consentManagement.overview.noPeferenceCenterHeaderMessage'
                })}
                body={intl.formatMessage({
                  id: 'consentManagement.overview.noPeferenceCenterBodyMessage'
                })}
                buttonLabel={intl.formatMessage({
                  id: 'consentManagement.overview.noPeferenceCenterButtonMessage'
                })}
                buttonSize={24}
                handleAction={() =>
                  historyService.push(URL_CONSENT_MANAGEMENT + URL_PREFERENCE_CENTER)
                }
              />
            ) : (
                selectedOption === optiontop5PreferenceCenters
                  ? allValuesAreZeroForPreferenceCenterListData
                  : allValuesAreZeroForConsentCategoriesListData
              ) ? (
              <DefaultNoViewContentType2
                SvgIcon={SvgNoValuePreferencCenterDatasource}
                body={intl.formatMessage({ id: 'consentManagement.noEventsLogged' })}
              />
            ) : (
              <div
                className={classNames('consents-by-type-chart-div', {
                  'po-consents-by-type': showSummary
                })}
              >
                <ChartPieWithList
                  centerTextStyles={{
                    fontSize: '0.7rem',
                    fontWeight: 500,
                    y: 100
                  }}
                  centerCountStyles={{
                    fontSize: '1.5rem',
                    fontWeight: 700,
                    y: 180 / 2 - 10
                  }}
                  data={
                    selectedOption === optiontop5PreferenceCenters &&
                    consentsByPreferenceCenterListData.length > 1
                      ? consentsByPreferenceCenterListData
                      : consentsCategoriesByPreferenceCenterListData
                  }
                  showLoader={false}
                  width={170}
                  totalLink={getTotalConsentsUrl}
                  {...(selectedOption !== optiontop5PreferenceCenters
                    ? { total: preferenceCenterTotalConsentRecordCount }
                    : '')}
                  text={
                    totalLegendText
                      ? totalLegendText
                      : language === DEFAULT_LANGUAGE
                      ? intl.formatMessage({ id: 'consentManagement.totalConsentsRecords' })
                      : intl.formatMessage({ id: 'preferenceCenter.tab.consents' })
                  }
                  horizontal={true}
                  denseList={true}
                  customToolTip={
                    <CustomTooltip
                      labelClassName="truncate"
                      title={
                        totalLegendText ||
                        intl.formatMessage({ id: 'consentManagement.totalConsentsRecords' })
                      }
                    />
                  }
                  listTitleColumnHeadings={{
                    heading1:
                      selectedOption === optiontop5PreferenceCenters &&
                      consentsByPreferenceCenterListData.length > 1
                        ? intl.formatMessage({
                            id: 'consentManagement.consentsByTypePreferenceCenterList.column_1'
                          })
                        : intl.formatMessage({
                            id: 'consentManagement.consentsByTypePreferenceCategory.column_1'
                          }),

                    heading2: intl.formatMessage({
                      id: 'consentManagement.consentsByType.column_2'
                    })
                  }}
                />
              </div>
            )}
            {
              <ChartBarLegends
                linkTitle={
                  consentsByPreferenceCenterOptions.length > 0
                    ? intl.formatMessage({ id: 'consentManagement.viewAllPreferenceCenters' })
                    : ''
                }
                linkHandler={() =>
                  historyService.push(URL_CONSENT_MANAGEMENT + URL_PREFERENCE_CENTER)
                }
              />
            }
          </div>
        </div>
      </WidgetCard>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    consentsCategoriesByPreferenceCenter:
      state.consentManagement.overview.consentsCategoriesByPreferenceCenter,
    preferenceCenterTotalConsentRecordCount:
      state.consentManagement.overview.preferenceCenterTotalConsentRecordCount,
    consentsByPreferenceCenterList: state.consentManagement.overview.consentsByPreferenceCenterList,
    totalPreferenceCenters: state.consentManagement.overview.totalPreferenceCenters,
    totalOptIns: state.consentManagement.overview.totalOptIns,
    totalOptOuts: state.consentManagement.overview.totalOptOuts,
    timePeriod: state.customDashboards.filterProps?.timePeriod,
    showLoaderPreferenceList: getShowLoader(
      ACTION_CONSENT_MANAGEMENT_CONSENTBY_PREFENRENCECENTER_LIST_WIDGET
    ),
    showLoaderConsentCategories: getShowLoader(
      ACTION_CM_CONSENTBY_TYPE_PREFERENCECENTER_CATEGORIES_WIDGET
    )
  }
}

const mapDispatchToProps = {
  fetchConsentManagementConsentByPreferenceCenterListWidget,
  fetchConsentManagementConsentCategoriesByPreferenceCenterId,
  fetchConsentOptStats
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsentsByTypeWidget)
